// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"modify_tooltip__2bTih","tooltiptext":"modify_tooltiptext__2ajF-"};